import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas';
import InputTextJSX from './InputTextJSX';
import { adminMainUrl } from '../../../../Config';
import axios from 'axios';
import { toast } from 'react-toastify';
import Select from "react-select";
import { customStyles } from '../../../../HelperFunctions';

const EditState = ({ state_id, show, handleClose, token, user_id, refresh, loadingCountry, destinationCountryData, loadingMasterStateDetail, MasterStateDetail }) => {

    console.log("destinationCountryData", destinationCountryData);
    console.log("MasterStateDetail", MasterStateDetail);
    const [disableSubmit, setDisableSubmit] = useState(false);
    const [countryOptions, setCountryOptions] = useState([]);
    let [showLoader, setShowLoader] = useState(false);
    let initialValues = {
        name: "",
        country_id: "",
        latitude: "",
        longitude: "",
    };

    useEffect(() => {
        if (destinationCountryData) {
            let arr = [];
            destinationCountryData.map(val => { arr.push({ value: val.id, label: val.name }) });
            setCountryOptions(arr);
        }
    }, [destinationCountryData]);

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values, { resetForm }) => {
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }
                if(state_id){
                    values.id = state_id
                }else{
                    toast.error("ID is required.");
                    return;
                }
                setDisableSubmit(true);
                axios.post(`${adminMainUrl}/api/master/state/edit`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            refresh();
                            // resetForm();
                            handleClose();
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });

    useEffect(() => {
        if (loadingMasterStateDetail) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }
        if (MasterStateDetail) {
            // console.log(MasterStateDetail);
            formik.setFieldValue("name", MasterStateDetail?.name);
            formik.setFieldValue("country_id", MasterStateDetail?.country_id);
            formik.setFieldValue("latitude", MasterStateDetail?.latitude);
            formik.setFieldValue("longitude", MasterStateDetail?.longitude);
        }
    }, [loadingMasterStateDetail, MasterStateDetail]);

    return (
        <>
            <Offcanvas show={show} onHide={handleClose} placement={"end"} name={"end"}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Update State</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <InputTextJSX
                                labelText={"State Name"}
                                nameValue={"name"}
                                value={formik.values.name}
                                onChange={formik.handleChange}
                            />


                            <div className={`col-md-6 mt-2`}>
                                <div className='ms-2'>
                                    <label htmlFor="" className='form-label  mb-0'>
                                        Country
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <Select
                                            className='custom-selector'
                                            options={countryOptions}
                                            styles={customStyles}
                                            name="country_id"
                                            onChange={option => {
                                                formik.setFieldValue('country_id', option.value);
                                            }}
                                            value={countryOptions.find(option => option.value == formik.values.country_id) || null}
                                            isLoading={loadingCountry}
                                        />
                                    </div>
                                </div>
                            </div>


                            <InputTextJSX
                                labelText={"Latitude"}
                                nameValue={"latitude"}
                                value={formik.values.latitude}
                                onChange={formik.handleChange}
                                maxLength={10}
                            />

                            <InputTextJSX
                                labelText={"Longitude"}
                                nameValue={"longitude"}
                                value={formik.values.longitude}
                                onChange={formik.handleChange}
                                maxLength={10}
                            />


                            <div className="row d-flex justify-content-end mt-2">
                                <div className="col-md-6 d-flex justify-content-end">
                                    <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                        {
                                            disableSubmit ?
                                                <>
                                                    <i className="fas fa-spinner fa-spin"></i> Saving...
                                                </>
                                                :
                                                "Update"
                                        }
                                    </button>
                                </div>
                            </div>


                        </div>
                    </form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default EditState